import styled from "styled-components";
import { colors } from "theme";

export const SearchBarWrapper = styled.header`
  background-color: #E5E2EF;
  padding: 25px;
  border-radius: 6px;
  margin-bottom: 24px;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
`;

export const ClaimsMisHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterBadgeWrapper = styled.span`
  border-radius: 999px;
  background-color: ${colors.primaryColor};
  width: 20px;
  height: 20px;
  display: grid;
  margin-left: 1rem;
  place-items: center;
  & p {
    color: white;
    font-size: 10px;
    top: 0;
    left: 0;
  }
`;

export const CheckboxContainer = styled.section`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const FilterSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`